export default __webpack_public_path__ + "static/media/alarmType.bc290af7.png";